module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("\n        " + _vm._s(_vm.row.label) + "–" + _vm._s(parseInt(_vm.row.label, 10) + 5) + "\n    ")]), _vm._v(" "), _vm._l((_vm.chosenRates), function(rates, index) {
    return _c('td', [_vm._v("\n        " + _vm._s(_vm.currencyFormat(_vm.row.data[index])) + "\n    ")])
  }), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.difference)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundValue(_vm.percent)) + "%")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e2d14e94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/components/tables/AgeGroupRow.vue
// module id = 1824
// module chunks = 0